import Ajv from "ajv";
import ToolboxInformationSchema from "./ToolboxInformation.json";
import ToolSpecV3Schema from "./ToolSpecV3.json";
import ToolPathSingleParamTypeV3Schema from "./ToolPathSingleParamTypeV3.json";
import ToolPathMultipleParamTypeV3Schema from "./ToolPathMultipleParamTypeV3.json";
import ToolIntParamTypeV3Schema from "./ToolIntParamTypeV3.json";
import ToolStringParamTypeV3Schema from "./ToolStringParamTypeV3.json";
import ToolFloatParamTypeV3Schema from "./ToolFloatParamTypeV3.json";
import ToolChoiceParamTypeV3Schema from "./ToolChoiceParamTypeV3.json";
import ToolBooleanParamTypeV3Schema from "./ToolBooleanParamTypeV3.json";
import ToolRoiFrameParamTypeV3Schema from "./ToolRoiFrameParamTypeV3.json";
import ToolCellStatusParamTypeV3Schema from "./ToolCellStatusParamTypeV3.json";
import { ToolSpecV3 } from "./ToolSpecV3";
import { ToolBooleanParamTypeV3 } from "./ToolBooleanParamTypeV3";
import { ToolCellStatusParamTypeV3 } from "./ToolCellStatusParamTypeV3";
import { ToolChoiceParamTypeV3 } from "./ToolChoiceParamTypeV3";
import { ToolFloatParamTypeV3 } from "./ToolFloatParamTypeV3";
import { ToolIntParamTypeV3 } from "./ToolIntParamTypeV3";
import { ToolPathSingleParamTypeV3 } from "./ToolPathSingleParamTypeV3";
import { ToolPathMultipleParamTypeV3 } from "./ToolPathMultipleParamTypeV3";
import { ToolRoiFrameParamTypeV3 } from "./ToolRoiFrameParamTypeV3";
import { ToolStringParamTypeV3 } from "./ToolStringParamTypeV3";
import { set } from "lodash";
import { ToolSpecV2 } from "components/ToolParamsGrid/ToolParamsGrid.types";
import { ImagesSpec } from "./ImagesSpec";
import ImagesSpecSchema from "./ImagesSpec.json";

export const isToolSpecV3 = new Ajv({
  strict: false,
  schemas: {
    "types/path_single_param_spec_schema.json": ToolPathSingleParamTypeV3Schema,
    "types/path_multiple_param_spec_schema.json":
      ToolPathMultipleParamTypeV3Schema,
    "types/string_param_spec_schema.json": ToolStringParamTypeV3Schema,
    "types/int_param_spec_schema.json": ToolIntParamTypeV3Schema,
    "types/float_param_spec_schema.json": ToolFloatParamTypeV3Schema,
    "types/choice_param_spec_schema.json": ToolChoiceParamTypeV3Schema,
    "types/boolean_param_spec_schema.json": ToolBooleanParamTypeV3Schema,
    "types/roi_frame_param_spec_schema.json": ToolRoiFrameParamTypeV3Schema,
    "types/cell_status_param_spec_schema.json": ToolCellStatusParamTypeV3Schema,
  },
}).compile<ToolSpecV3>(ToolSpecV3Schema);

export type ToolParamV3 = ToolSpecV3["params"][number];

const _isToolParamV3 = new Ajv({
  strict: false,
  schemas: {
    "types/path_single_param_spec_schema.json": ToolPathSingleParamTypeV3Schema,
    "types/path_multiple_param_spec_schema.json":
      ToolPathMultipleParamTypeV3Schema,
    "types/string_param_spec_schema.json": ToolStringParamTypeV3Schema,
    "types/int_param_spec_schema.json": ToolIntParamTypeV3Schema,
    "types/float_param_spec_schema.json": ToolFloatParamTypeV3Schema,
    "types/choice_param_spec_schema.json": ToolChoiceParamTypeV3Schema,
    "types/boolean_param_spec_schema.json": ToolBooleanParamTypeV3Schema,
    "types/roi_frame_param_spec_schema.json": ToolRoiFrameParamTypeV3Schema,
    "types/cell_status_param_spec_schema.json": ToolCellStatusParamTypeV3Schema,
  },
}).compile<ToolParamV3>(ToolSpecV3Schema.properties.params.items);

export interface ToolBooleanParamV3 extends ToolParamV3 {
  type: ToolBooleanParamTypeV3;
}

const ToolBooleanParamV3Schema = ToolSpecV3Schema.properties.params.items;
set(ToolBooleanParamV3Schema, "properties.type", ToolBooleanParamTypeV3Schema);

export const isToolBooleanParamV3 = new Ajv({
  strict: "log",
  strictSchema: "log",
}).compile<ToolBooleanParamV3>(ToolBooleanParamV3Schema);

export interface ToolCellStatusParamV3 extends ToolParamV3 {
  type: ToolCellStatusParamTypeV3;
}

const ToolCellStatusParamV3Schema = ToolSpecV3Schema.properties.params.items;
set(
  ToolCellStatusParamV3Schema,
  "properties.type",
  ToolCellStatusParamTypeV3Schema,
);

export const isToolCellStatusParamV3 = new Ajv({
  strict: false,
}).compile<ToolCellStatusParamV3>(ToolCellStatusParamV3Schema);

export interface ToolChoiceParamV3 extends ToolParamV3 {
  type: ToolChoiceParamTypeV3;
}

const ToolChoiceParamV3Schema = ToolSpecV3Schema.properties.params.items;
set(ToolChoiceParamV3Schema, "properties.type", ToolChoiceParamTypeV3Schema);

export const isToolChoiceParamV3 = new Ajv({
  strict: false,
}).compile<ToolChoiceParamV3>(ToolChoiceParamV3Schema);

export interface ToolFloatParamV3 extends ToolParamV3 {
  type: ToolFloatParamTypeV3;
}

const ToolFloatParamV3Schema = ToolSpecV3Schema.properties.params.items;
set(ToolFloatParamV3Schema, "properties.type", ToolFloatParamTypeV3Schema);

export const isToolFloatParamV3 = new Ajv({
  strict: false,
}).compile<ToolFloatParamV3>(ToolFloatParamV3Schema);

export interface ToolIntParamV3 extends ToolParamV3 {
  type: ToolIntParamTypeV3;
}

const ToolIntParamV3Schema = ToolSpecV3Schema.properties.params.items;
set(ToolIntParamV3Schema, "properties.type", ToolIntParamTypeV3Schema);

export const isToolIntParamV3 = new Ajv({
  strict: false,
}).compile<ToolIntParamV3>(ToolIntParamV3Schema);

interface ToolPathSingleParamV3 extends ToolParamV3 {
  type: ToolPathSingleParamTypeV3;
}

const ToolPathSingleParamV3Schema = ToolSpecV3Schema.properties.params.items;
set(
  ToolPathSingleParamV3Schema,
  "properties.type",
  ToolPathSingleParamTypeV3Schema,
);

const isToolPathSingleParamV3 = new Ajv({
  strict: false,
}).compile<ToolPathSingleParamV3>(ToolPathSingleParamV3Schema);

interface ToolPathMultipleParamV3 extends ToolParamV3 {
  type: ToolPathMultipleParamTypeV3;
}

const ToolPathMultipleParamV3Schema = ToolSpecV3Schema.properties.params.items;
set(
  ToolPathMultipleParamV3Schema,
  "properties.type",
  ToolPathMultipleParamTypeV3Schema,
);

const isToolPathMultipleParamV3 = new Ajv({
  strict: false,
}).compile<ToolPathMultipleParamV3>(ToolPathMultipleParamV3Schema);

interface ToolPathParamV3 extends ToolParamV3 {
  type: ToolPathSingleParamTypeV3 | ToolPathMultipleParamTypeV3;
}

export const isToolPathParamV3 = <T>(
  data: T | ToolPathParamV3,
): data is ToolPathParamV3 => {
  return isToolPathSingleParamV3(data) || isToolPathMultipleParamV3(data);
};

export interface ToolRoiFrameParamV3 extends ToolParamV3 {
  type: ToolRoiFrameParamTypeV3;
}

const ToolRoiFrameParamV3Schema = ToolSpecV3Schema.properties.params.items;
set(
  ToolRoiFrameParamV3Schema,
  "properties.type",
  ToolRoiFrameParamTypeV3Schema,
);

export const isToolRoiFrameParamV3 = new Ajv({
  strict: false,
}).compile<ToolRoiFrameParamV3>(ToolRoiFrameParamV3Schema);

export interface ToolStringParamV3 extends ToolParamV3 {
  type: ToolStringParamTypeV3;
}

const ToolStringParamV3Schema = ToolSpecV3Schema.properties.params.items;
set(ToolStringParamV3Schema, "properties.type", ToolStringParamTypeV3Schema);

export const isToolStringParamV3 = new Ajv({
  strict: false,
}).compile<ToolStringParamV3>(ToolStringParamV3Schema);

type ParamType = ToolSpecV3["params"][number]["type"]["param_type"];
/**
 * Type guard to narrow the param type of a tool param
 * @param paramType Param Type (e.g. "ToolPathParam")
 * @param param A tool param
 */
export const isToolParamV3 = <T extends ParamType>(
  param: unknown,
  paramType?: T,
): param is ToolParamV3 & {
  type: Extract<ToolSpecV3["params"][number]["type"], { param_type: T }>;
} => {
  if (paramType === undefined) {
    return _isToolParamV3(param);
  }

  switch (paramType) {
    case "ToolBooleanParam":
      return isToolBooleanParamV3(param);
    case "ToolPathParam":
      return isToolPathParamV3(param);
    case "ToolStringParam":
      return isToolStringParamV3(param);
    case "ToolIntRangeParam":
      return isToolIntParamV3(param);
    case "ToolFloatRangeParam":
      return isToolFloatParamV3(param);
    case "ToolChoiceParam":
      return isToolChoiceParamV3(param);
    case "ToolRoiFrameParam":
      return isToolRoiFrameParamV3(param);
    case "ToolCellStatusParam":
      return isToolCellStatusParamV3(param);
  }
  return false;
};

export const isFileFormatsV3 = new Ajv({ strict: false }).compile<
  NonNullable<ToolPathSingleParamTypeV3["file_formats"]>
>(ToolPathSingleParamTypeV3Schema.properties.file_formats);

export const isFileTagsV3 = new Ajv({ strict: false }).compile<
  NonNullable<
    ToolPathSingleParamTypeV3["tags"] & ToolPathSingleParamTypeV3["tags"]
  >
>(ToolPathSingleParamTypeV3Schema.properties.tags);

export const isFilePatternsV3 = new Ajv({ strict: false }).compile<
  ToolSpecV3["results"][number]["file_patterns"]
>(ToolSpecV3Schema.properties.results.items.properties.file_patterns);

export type ToolSpec = ToolSpecV2 | ToolSpecV3;

const ToolSpecV2Schema = ToolboxInformationSchema.properties.tools.items;

export const isToolSpecV2 = new Ajv({
  strict: false,
}).compile<ToolSpecV2>(ToolSpecV2Schema);

export type ImageSpec = ImagesSpec[number];

export const isImageSpec = new Ajv({
  strict: false,
}).compile<ImageSpec>(ImagesSpecSchema.items);
